// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  text-align: left;
}
:host .center {
  text-align: center;
}
:host .right {
  text-align: right;
}
:host .info-text {
  width: 100%;
  height: 50px;
  margin-top: 0;
  margin-bottom: 0;
  background-color: rgb(93, 76, 68);
  padding-left: 1em;
  padding-right: 1em;
  line-height: 3em;
  color: white;
  border: 2px solid var(--ion-color-primary);
}
:host .bold_title {
  color: var(--ion-color-secondary);
}
:host .brown {
  color: white;
}
:host #criteria {
  background-color: #fff;
  width: 100%;
  height: 50px;
  border: 2px solid #fc0;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
:host #critcontainer {
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 98px;
}
:host #whitespace {
  height: 0;
  background-color: #ffffff;
}
:host .beersfound {
  width: 70%;
}
:host #show {
  height: 30px;
  vertical-align: middle;
  right: 1em;
  margin: 0;
}
:host p #cri span {
  vertical-align: top;
}
:host .cross-class {
  vertical-align: top;
}
:host .noitems {
  margin-left: 10px;
  margin-top: 0px;
  padding-top: 0px;
  font-size: 18px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
